import { RDStationCRMPluginSettingsData, RDStationCRMPipelineResponse, RDStationCRMPipeline } from "@/protocols/RdStationPluginProtocol"
import ApiService from "@/services/Api"

export type RDStationCRMEncryptStateDataInput = {
	pluginId: number
	data: {
		clientId: string
		clientSecret: string
	}
}

export type RDStationCRMEncryptStateDataOutput = {
	token: string
	clientId: string
	clientSecret: string
}

export type RDStationCRMEncryptStateDataResponse = {
	rdStationCredentials: {
		token: string
		clientId: string
		clientSecret: string
	}
}

type CheckAuthCredentialsResponse = {
	dataValues: RDStationCRMPluginSettingsData
}

class RDStationCRMService {
	async checkAuthCredentials (): Promise<RDStationCRMPluginSettingsData> {
		const response = await ApiService.get<CheckAuthCredentialsResponse>("/plugin-settings/rd-station-crm/check-auth-credentials")

		return response.data.dataValues
	}

	async encryptStateData (input: RDStationCRMEncryptStateDataInput): Promise<RDStationCRMEncryptStateDataOutput> {
		const response = await ApiService.post<RDStationCRMEncryptStateDataResponse>(`/plugin-settings/${input.pluginId}/rd-station-crm/encrypt-state-data`, input.data)

		return response.data.rdStationCredentials
	}

	async revoke (pluginId: number): Promise<void> {
		await ApiService.post("/plugin-settings/rd-station-crm/revoke", { pluginId })
	}

	async getPipelines (): Promise<RDStationCRMPipeline[]> {
		const response = await ApiService.get<RDStationCRMPipelineResponse>("/plugin-settings/rd-station-crm/pipelines")

		return response.data.dealGroups
	}
}

export default new RDStationCRMService()
